module.exports = __webpack_public_path__ + "static/media/5ed73bcfb2f15c60f8d7007d.bfa4ea4e.png";